import { defineComponent as _defineComponent } from 'vue'
import { IEigenvalueInfo } from '@/api/moudules/wave.types';
import NormalTable from '@/components/Table/NormalTable.vue';
import { E_Eigenvalue } from '@/types';
import { toFixed } from '@/utils/math';
import { getEigenvalueDomainUnit } from '@/utils/units';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'EigenvalueShow',
  props: {
    eigenvalueType: null,
    eigenvalue: null
  },
  emits: ["close"],
  setup(__props: any, { emit: emits }: { emit: ({
    (e: 'close')
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    eigenvalueType: E_Eigenvalue
    eigenvalue: IEigenvalueInfo
}





function onClose() {
    emits('close')
}

const dis = computed(() => {
    const {
        z1, z2, z3, z4, z5, z6, z7, z8, z9, z10
    } = props.eigenvalue
    return {
        z1: toFixed(z1, 3),
        z2: toFixed(z2, 3),
        z3: toFixed(z3, 3),
        z4: toFixed(z4, 3),
        z5: toFixed(z5, 3),
        z6: toFixed(z6, 3),
        z7: toFixed(z7, 3),
        z8: toFixed(z8, 3),
        z9: toFixed(z9, 3),
        z10: toFixed(z10, 3)
    }
})

const unit = computed(() => {    
    return getEigenvalueDomainUnit(props.eigenvalueType).y
})


return { __sfc: true,props, emits, onClose, dis, unit, NormalTable }
}

})